// Transport orchestration for the existing explicit bonus decision: never automatic retry.
export const requestWithBonusRecovery = async ({
  params, requestLaunch, isCurrent, extractGate, confirm, reserve, duplicate,
}) => {
  const response = await requestLaunch(params);
  if (!isCurrent()) return { error: 'stale_game_launch' };
  const gate = extractGate(response);
  if (!gate) return { response };
  const accepted = await confirm(gate);
  if (!isCurrent()) return { error: 'stale_game_launch' };
  if (gate.actionType === 'BLOCK' || !accepted) {
    return { error: gate.actionType === 'BLOCK' ? 'bonus_game_restricted' : 'bonus_recovery_cancelled' };
  }
  if (!reserve().success) {
    duplicate();
    return { error: 'duplicate_game_running' };
  }
  const retryResponse = await requestLaunch({ ...params, is_bonus_recover: true });
  if (!isCurrent()) return { error: 'stale_game_launch' };
  const retryGate = extractGate(retryResponse);
  if (retryGate) {
    await confirm({ ...retryGate, actionType: 'BLOCK' });
    return { error: isCurrent() ? 'bonus_recovery_rejected' : 'stale_game_launch' };
  }
  return { response: retryResponse };
};
